export class InactivityTime{
  public static readonly MINUTES = 3;
  public static readonly SECONDS = 60;
  public static readonly MILLISECONDS = 1000;
  public static readonly THIRTY_MINUTES = 30;
}
